import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IVideoGalleryDetails } from "../videogalleryModal";

export const getAllVideoGallerys = createAsyncThunk(
  "VideoGallery/FindAllVideoGallery",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VideoGallery/FindAllVideoGallery`,
        {
          Title: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Video Gallery:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createVideoGallery = createAsyncThunk(
  "VideoGallery/InsertVideoGallery",
  async (VideoGalleryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VideoGallery/InsertVideoGallery`,
        VideoGalleryData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Video Gallery:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateVideoGallery = createAsyncThunk(
  "VideoGallery/UpdateVideoGallery",
  async (VideoGalleryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VideoGallery/UpdateVideoGallery`,
        VideoGalleryData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Video Gallery:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteVideoGallery = createAsyncThunk(
  "VideoGallery/DeleteVideoGallery",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VideoGallery/DeleteVideoGallery`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Video Gallery:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getVideoGalleryByID = createAsyncThunk(
  "VideoGallery/FindByIDVideoGallery",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VideoGallery/FindByIDVideoGallery`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result?.Title ?? "",
        VideoURL: result?.VideoURL ?? "",
        IsActive: result.IsActive ? 1 : 2,
      } as IVideoGalleryDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Video Gallery:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveVideoGallerys = createAsyncThunk(
  "VideoGallery/FindAllActiveVideoGallery",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/VideoGallery/FindAllActiveVideoGallery`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Video Gallery:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveVideoGallery = createAsyncThunk(
  "VideoGallery/ActiveInActiveVideoGallery",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VideoGallery/ActiveInActiveVideoGallery`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Video Gallery:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

